<template>
  <!-- 配置属性 -->
  <el-dialog
    title="配置属性"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    class="dialog"
    center
  >
    <div class="d-flex a-center nameWrap">
      当前品类
      {{ info && info.name ? `${info.first_category.name}-${info.name}` : "" }}
    </div>
    <div class="contentWrap">
      <el-checkbox-group v-model="field_keys">
        <el-checkbox
          v-for="item in checkData"
          :key="item.field_key"
          :label="item.field_key"
          >{{ item.field_key }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onHandleSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { postCategoriesCustomFieldList } from "@/api/generalControl/key-attributes.js";
import { postCategoriesSearchItemSave } from "@/api/generalControl/category";
export default {
  name: "configProperties",
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      checkData: [],
      field_keys: [],
      params: {
        source: 1,
        cid: "",
        logistic_business_id: "",
      },
      info: {},
    };
  },
  computed: {},
  methods: {
    onInitData(e) {
      console.log(e, "e==");
      this.params.cid = e.cid;
      this.params.logistic_business_id = e.logistic_business_id;
      this.dialogVisible = true;
      this.field_keys = [];
      this.postAjaxCategoriesCustomFieldList();
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
    async onHandleSubmit() {
      console.log(this.field_keys, "field_keys==");

      this.submitLoading = true;
      try {
        const res = await postCategoriesSearchItemSave({
          cid: this.params.cid,
          logistic_business_id: this.params.logistic_business_id,
          field_key: this.field_keys.join(","),
        });
        this.$message({
          type: "success",
          message: "配置成功",
        });
        this.dialogVisible = false;
      } catch (error) {
        console.log(error, "postCategoriesSearchItemSave");
      } finally {
        this.submitLoading = false;
      }
    },
    /**
     * 列表数据
     */
    async postAjaxCategoriesCustomFieldList() {
      this.checkData = [];
      try {
        const res = await postCategoriesCustomFieldList(this.params);
        this.checkData = res.data.list;
        this.info = res.data.info;
        let tmpArr = [];
        res.data.list.map((rItem) => {
          // 已经配置的属性回显
          if (rItem.is_selected == 1) {
            tmpArr.push(rItem.field_key);
          }
        });
        this.field_keys = tmpArr || [];
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldList");
      } finally {
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.nameWrap {
  font-size: 15px;
  padding: 10px 0px 10px 40px;
}
.contentWrap {
  margin-top: 10px;
  padding: 0px 0px 10px 40px;
}
</style>
